{
  "name": "everydoggy-payment",
  "version": "1.0.10",
  "description": "",
  "browserslist": "> 0.5%, last 2 versions, not dead",
  "scripts": {
    "start": "tsc && (parcel ./src/index.html --target legacy)",
    "test": "jest",
    "tests": "parcel ./src/index.html --port 1984",
    "https": "parcel ./src/index.html --https",
    "build": "tsc && (parcel build ./src/index.html --dist-dir dist --public-url ./ --no-scope-hoist)",
    "prepare": "husky install",
    "tsc:w": "tsc -w",
    "lint": "eslint \"src/**/*.{js,jsx,ts,tsx}\"",
    "lint:fix": "eslint --fix \"src/**/*.{js,jsx,ts,tsx}\""
  },
  "repository": {
    "type": "git",
    "url": "git+ssh://git@bitbucket.org/runnerredrock/verv-stripe-web.git"
  },
  "targets": {
    "legacy": {
      "engines": {
        "browsers": "> 0.001%, last 20 versions"
      }
    }
  },
  "author": "",
  "license": "ISC",
  "homepage": "https://bitbucket.org/runnerredrock/verv-stripe-web#readme",
  "dependencies": {
    "@amplitude/analytics-browser": "^2.33.1",
    "@babel/core": "^7.19.3",
    "@babel/plugin-transform-runtime": "^7.19.1",
    "@babel/preset-env": "^7.19.4",
    "@babel/preset-react": "^7.18.6",
    "@glidejs/glide": "^3.6.2",
    "@parcel/transformer-sass": "^2.7.0",
    "@paypal/react-paypal-js": "^8.6.0",
    "@reduxjs/toolkit": "^1.8.6",
    "@stripe/react-stripe-js": "^1.13.0",
    "@stripe/stripe-js": "^1.41.0",
    "@verv-inc/js-toolkit": "1.0.11",
    "autoprefixer": "^10.4.12",
    "classnames": "^2.3.2",
    "cli-progress": "^3.11.2",
    "core-js-compat": "^3.25.5",
    "crypto-js": "^4.1.1",
    "email-validator": "^2.0.4",
    "eslint-config-prettier": "^8.5.0",
    "eslint-plugin-prettier": "^4.2.1",
    "fs-extra": "^10.1.0",
    "googleapis": "^108.0.0",
    "husky": "^8.0.1",
    "modern-css-reset": "^1.4.0",
    "parcel": "^2.7.0",
    "postcss": "^8.4.6",
    "postcss-modules": "^4.3.0",
    "postcss-nested": "^6.0.0",
    "postcss-scss": "^4.0.5",
    "prettier": "^2.7.1",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "react-redux": "^8.0.4",
    "react-toastify": "^9.0.8",
    "styled-components": "^5.3.6",
    "typescript": "^4.8.4"
  },
  "devDependencies": {
    "@playwright/test": "^1.27.1",
    "@types/jest": "^29.1.2",
    "@types/node": "^18.11.2",
    "@types/react": "^18.0.21",
    "@types/react-dom": "^18.0.6",
    "@types/react-redux": "^7.1.24",
    "@types/react-router-dom": "^5.3.3",
    "@types/styled-components": "^5.1.26",
    "@typescript-eslint/eslint-plugin": "^5.40.1",
    "@typescript-eslint/parser": "^5.40.1",
    "eslint": "^8.25.0",
    "eslint-plugin-react": "^7.31.10",
    "ts-jest": "^29.0.3"
  },
  "alias": {
    "process": false
  }
}
